import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "9ff0ee8a-d83b-4969-9a21-e4edc248a0b8",
    content: "Acoustical simulations are essential for a detailed architectural acoustic design.",
    options: {},
  },
  {
    id: "fec3398d-250a-4c42-a25d-14a43ac8ba10",
    content: "Auralization plug-ins are available for some architectural design software packages.",
    options: {},
  },
  {
    id: "880c50c6-1d5f-4446-a6a1-12c53d4add94",
    content: "Absorbers are useful to improve the acoustic properties in a room.",
    options: {},
  },
  {
    id: "acc937ca-9922-4e94-bc00-c999eb197ae2",
    content: "It is easy to choose correct input data for acoustic properties of materials.",
    options: {},
  },
];

export const task: Task = {
  id: "dbe19417-973c-4c8e-a1eb-387a33011f4f",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "9ff0ee8a-d83b-4969-9a21-e4edc248a0b8",
    "fec3398d-250a-4c42-a25d-14a43ac8ba10",
    "880c50c6-1d5f-4446-a6a1-12c53d4add94",
  ],
};
